var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"voucher-card my-3",style:(_vm.cssStyle),attrs:{"height":"300","width":"1200","dark":""},on:{"click":function($event){return _vm.$emit('click')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }